import React, { useState, useEffect, useMemo, useRef } from "react";
import { Card, Button, InputNumber, Spin, Modal, message } from "antd";
import { useWindowSize } from "react-use";




const MotivationScreen = ({ message, onStart ,user}) => {
  const { width, height } = useWindowSize();
  const [showStartButton, setShowStartButton] = useState(false);
  // const isMobile = /Android|iPhone|iPod/i.test(navigator.userAgent);
 const isMobile = width < 768;
 useEffect(() => {
  let utterance;
const speakMotivation = () => {
  if (
    typeof window === "undefined" ||
    !window.speechSynthesis
  ) {
    return;
  }

  try {
    window.speechSynthesis.cancel();

    const utter = new SpeechSynthesisUtterance(`${user?.username} , You are ${message}! You can do it! `);

    utter.lang = "en-US";
    utter.volume = 1;

    const voices = window.speechSynthesis.getVoices();

    if (isMobile) {
      // Mobile voice
      utter.rate = 0.85;
      utter.pitch = 1;

      utter.voice =
        voices.find((v) => /female|samantha|susan/i.test(v.name)) ||
        voices.find((v) => /en-US/i.test(v.lang)) ||
        voices[0];
    } else {
      // Desktop voice
      utter.rate = 1.05;
      utter.pitch = 1.8;

      utter.voice =
        voices.find((v) => /zira/i.test(v.name)) ||
        voices.find((v) => /en-US/i.test(v.lang)) ||
        voices[0];
    }

    window.speechSynthesis.speak(utter);
  } catch (error) {
    console.error("Speech error:", error);
  }
};
//   const speakMotivation = () => {
//     utterance = new SpeechSynthesisUtterance(`${user?.username} , You are ${message}! You can do it! `);
//    utterance.lang = "en-US";
//       utterance.rate = isMobile ?  0.90 : 1.05;
//       utterance.pitch = 1.8;
//       utterance.volume = 2;

//     const voices = window.speechSynthesis.getVoices();
//     // pick a suitable voice or fallback
//     //utterance.voice = voices.find(v => v.name.toLowerCase().includes("zira") || v.name.toLowerCase().includes("child")) || voices[0];
//     // utterance.voice = voices.find(v => v.name.toLowerCase().includes("zira"));
//  utterance.voice = isMobile ? voices.find((v) => /child/i.test(v.name)) : voices.find((v) => /zira/i.test(v.name));
//     window.speechSynthesis.speak(utterance);
//   };

  // ensure voices are loaded
  if (window.speechSynthesis.getVoices().length === 0) {
    window.speechSynthesis.onvoiceschanged = () => {
      speakMotivation();
    };
  } else {
    speakMotivation();
  }

  const timer = setTimeout(() => setShowStartButton(true), 3000);

  return () => {
    clearTimeout(timer);
    // stop any ongoing speech when component unmounts
    if (utterance) window.speechSynthesis.cancel();
  };
}, [message]);


  return (
    <div style={{
      margin: -10, display: "flex", flexDirection: "column",
      alignItems: "center", 
      //justifyContent: "center",
      // minHeight: "500vh",
      background: "linear-gradient(135deg, #3ca9e9ff, #07689f)", 
     boxShadow: "0 14px 32px rgba(5, 85, 130, 0.55)",
//boxShadow: "0 0 22px rgba(162, 213, 242, 0.6)",
paddingBottom:80,
      color: "#fff", textAlign: "center", position: "relative"
    }}>
      <div style={{ fontSize: 200 }}>⛄</div>
      <h1 style={{ fontSize: 40, fontWeight: "bold", margin: 20 }}>You are {message}!</h1>
      <p style={{ fontSize: 28, marginBottom: 40 }}>You can do it! Let's solve this quiz together! 🎉</p>
      {showStartButton && <Button type="primary" size="large" style={{ fontSize: 28, 
        backgroundColor:"orange"  ,padding: "20px 40px", borderRadius: 20 }} onClick={onStart}>
        Start Quiz
      </Button>}
    </div>
  );
};
export default MotivationScreen;